export default __webpack_public_path__ + "static/media/checkboxOn.8ca0f61e.svg";